

function roundtocloses0_5_value(value) {
  if (isNaN(value)) {
    return 0;
  }
  return Math.round(value * 2) / 2
}

export default roundtocloses0_5_value
